import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router';

import { requireRole } from '@/helpers/permissions';
import EmployeeForm from '@/components/EmployeeForm';
import Page from '@/pages/Page';

export default requireRole('owner', EditEmployeePage);

function EditEmployeePage() {
  const {uuid} = useParams();
  const history = useHistory();
  const employee = useSelector((store) => _.find(store.employees, {uuid}));

  const goToIndex = () => history.push('/employees');

  return (
    <Page title="Edit Employee" backDefault="/employees">
      <EmployeeForm employee={employee} done={goToIndex}/>
    </Page>
  );
}
